import { Adapter as r } from "../../../../../../../adapter.js";
import { TierCycleRuleModel as a } from "./tierCycleRule.model.js";
class m extends r {
  adapt(e) {
    return new a({
      minBalance: e.min_balance
    });
  }
  serialize(e) {
  }
}
export {
  m as TierCycleRuleAdapter
};
//# sourceMappingURL=tierCycleRule.adapter.js.map
